module.exports = __webpack_public_path__ + "lv.d24278f8.svg";